import React from 'react';
import Icon from './AppIcon';

const KakaoChatButton = () => {
  return (
    <a
      href="http://pf.kakao.com/_IRxoxmn/chat"
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 flex items-center gap-2 rounded-full bg-[#FEE500] px-4 py-3 text-sm font-semibold text-black shadow-lg transition-colors hover:bg-[#FADA0A] focus:outline-none focus:ring-2 focus:ring-black/20"
      aria-label="카카오톡 문의"
    >
      <span className="flex h-8 w-8 items-center justify-center rounded-full bg-black/0">
        <Icon name="MessageCircle" size={22} color="#000000" fill="#000000" strokeWidth={0} />
      </span>
      <span>문의</span>
    </a>
  );
};

export default KakaoChatButton;
